import { S3Browser } from "./S3Browser";

interface S3BrowserModalProps {
  onClose: () => void;
}

export const S3BrowserModal = ({ onClose }: S3BrowserModalProps) => {
  return (
    <div
      className="dialog-wrapper"
      aria-modal="true"
      data-testid="s3-browser-modal"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 10000,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={(e) => {
        if ((e.target as HTMLDivElement).classList.contains("dialog-wrapper")) {
          onClose();
        }
      }}
    >
      <div
        className="dialog"
        style={{
          minWidth: "960px",
          maxWidth: "90%",
          maxHeight: "90%",

          overflowY: "auto",
          position: "relative",
        }}
      >
        <div className="dialog-contents">
          <S3Browser
            onClose={function (): void {
              onClose();
            }}
          />
        </div>
      </div>
    </div>
  );
};
